import { MappingEntity } from '../../abstract-mapping-entity';
import { IWritebackRuleEntity } from '../interface-writeback-rule-entity';

/**
 * ååè§åå®ä½ç±»
 */
export class AifWritebackRuleEntity extends MappingEntity implements IWritebackRuleEntity {

}